$(function () {
  handleDepartmentSection();
});

function handleDepartmentSection() {
  const selectDepartment = $("#js-department-select");
  const departments = $(".js-department");

  selectDepartment.on("change", function () {
    const selectedDepartment = $(this).find("option:selected").val();
    departments.each(function () {
      const department = $(this).data("department");

      if (selectedDepartment === department || selectedDepartment === "All") {
        $(this).slideDown(300);
      } else {
        $(this).slideUp(300);
      }
    });
  });
}
